import React from 'react';
import { ClockIcon } from '@heroicons/react/24/solid';
import { getCategoryColor } from '../../utils/categoryColors';
import { getEventPlaceholder } from '../../utils/eventPlaceholder';

const CompactCard = ({ event, formatEventDate, onOpenModal }) => (
  <div
    onClick={() => onOpenModal(event)}
    className="flex-shrink-0 snap-start w-[140px] min-[380px]:w-[160px] sm:w-56 bg-white rounded-2xl border border-gray-100 overflow-hidden cursor-pointer group hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
  >
    <div className="relative aspect-[4/5] overflow-hidden min-h-[200px] max-h-[260px]">
      <img src={event.photoUrl || getEventPlaceholder(event.category)} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" alt="" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
      <div className="absolute bottom-3 left-3 right-3">
        <h4 className="text-sm font-bold text-white leading-snug line-clamp-2">{event.title}</h4>
        <p className="text-[11px] text-white/80 mt-1 flex items-center gap-1">
          <ClockIcon className="h-3 w-3 flex-shrink-0" />
          {formatEventDate(event.start, event.end)}
        </p>
      </div>
      <div className="absolute top-2 left-2 h-4 w-full rounded-b" style={{ maxWidth: '4px', height: '100%', backgroundColor: getCategoryColor(event.category).primary, borderRadius: '4px', opacity: 0.9, maxHeight: '40%' }} />
    </div>
  </div>
);

export default CompactCard;
